
export default {
	data() {
		return {
			baseURL: window.location.origin,
			objetivos_api: {},
			campos_objetivo: {
				pr_renda_fixa: '',
				pr_renda_variavel: '',
				pr_renda_variavel_eua: '',
				pr_renda_variavel_br: '',
			},
			objetivos: {
				acoes: [],
				fiis: [],
				stocks: [],
				reits: [],
				titulos: [],
			},
			tipo_atual: '',
			product_type_name: '',

			step: {
				id: 1,
				tipo: ""
			},
			modalActive: '',
			nome_correto: '',
			loading: false,
			errorSteps: [],
			modal1: null,
			status_campos: {
				no_has_renda_variavel: false,
				no_has_br: false,
				no_has_acoes: false,
				no_has_fiis: false,
				no_has_eua: false,
				no_has_reits: false,
				no_has_stocks: false,
			},

			origin_click: '',
			quantidadeItens: 3,
			verMaisIsOpen: false,
			tipo_atual: '',
			tiposInvestimento: {
				acoes: [],
				fiis: [],
				stocks: [],
				reits: [],
				tesouroDireto: []
			},
			naoMostrarNovamente: false,
			incorretos: []

		}


	},


	async mounted() {

		this.modal1 = ModalX('.modal-edicao-objetivo', {
			deep: true,
			zIndex: 300000,
			zIndexDeep: 20000,
			bgModal: 'rgb(30,33,36)',
			closeOnDeep: false,
		})


		this.naoMostrarNovamente = GLOBAL.getCookie('naoMostrarNovamente') == 'true' ? true : false

		const cardItem = document.querySelector(`.step-${this.step.id}`)
		this.modalActive = this.modal1;
		this.modalActive.init()
		await this.getDataFromObjective()
		await this.getObjetivos()
		await this.verifyIfReceivedValuesIsNull()
		// await this.persistErrorIfHasInvalidModal(modal1)
		await axios.get(`${this.baseURL}/api/ativos_variaveis/?onde_aportar=1`)
			.then(({ data }) => {
				console.log(data)
				this.tiposInvestimento.acoes = data.filter((i) => i.product_type_name === 'Ações').sort(({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a);
				this.tiposInvestimento.fiis = data.filter((i) => i.product_type_name === 'FII - Fundo de Investimento Imobiliário').sort(({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a);
				this.tiposInvestimento.stocks = data.filter((i) => i.product_type_name === 'Stock').sort(({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a);
				this.tiposInvestimento.reits = data.filter((i) => i.product_type_name === 'REIT').sort(({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a);
			})
			.catch(error => {
				GLOBAL.showToastify(error)
				console.error(error)
			})

		await axios.get(`${this.baseURL}/api/titulos_tesouro/?onde_aportar=1`)
			.then(({ data }) => {
				this.tiposInvestimento.tesouroDireto = data.filter((i) => i.product_type_name === 'TesouroDireto').sort(({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a);
			})
			.catch(error => {
				GLOBAL.showToastify(error)
				console.error(error)
			})
		await this.getObjetivosIncorretos()
		if (this.naoMostrarNovamente) return

	},

	computed: {
		toggleVerMais() {
			return this.quantidadeItens == 3 ? 'Ver mais' : 'Ver menos';
		}
	},

	methods: {
		setPatternInputValue(value) {
			return value == null || isNaN(value) ? 0 : Number(value)
		},
		async getDataFromObjective() {
			this.loading = true
			await axios.get(`${this.baseURL}/api/objetivo/`)
				.then(({ data }) => {

					this.objetivos_api = data;
					this.campos_objetivo.pr_renda_fixa = Number(this.setPatternInputValue(this.objetivos_api[0]?.pr_renda_fixa))
					this.campos_objetivo.pr_renda_variavel = Number(this.setPatternInputValue(this.objetivos_api[0]?.pr_renda_variavel))
					this.campos_objetivo.pr_renda_variavel_br = Number(this.setPatternInputValue((this.objetivos_api[0]?.pr_renda_variavel_br)).toFixed(2))
					this.campos_objetivo.pr_renda_variavel_eua = Number(this.setPatternInputValue((this.objetivos_api[0]?.pr_renda_variavel_eua)).toFixed(2))
					this.campos_objetivo.pr_acoes = Number(this.setPatternInputValue((this.objetivos_api[0]?.pr_acoes)).toFixed(2))
					this.campos_objetivo.pr_fiis = Number(this.setPatternInputValue((this.objetivos_api[0]?.pr_fiis)).toFixed(2))
					this.campos_objetivo.pr_stocks = Number(this.setPatternInputValue((this.objetivos_api[0]?.pr_stocks)).toFixed(2))
					this.campos_objetivo.pr_reits = Number(this.setPatternInputValue((this.objetivos_api[0]?.pr_reits)).toFixed(2))

				})
				.catch(error => {
					GLOBAL.showToastify(error, '#DE4B4F')
					console.error(error)
				})
				.finally(() => {
					this.loading = false
				});
		},

		/* Funções de controle dos steps do wizard*/
		verifyStepAndSetThePatterns(current, tipo = 'default') {
			if (this.step.id == current) {
				this.step.tipo = tipo
				this.tipo_atual = tipo
			}
		},

		defineTypeProduct(variable) {
			switch (variable) {
				case 'acoes':
					this.product_type_name = 'Ações';
					break
				case 'fiis':
					this.product_type_name = 'FII - Fundo de Investimento Imobiliário'
					break
				case 'stocks':
					this.product_type_name = 'Stock'
					break
				case 'reits':
					this.product_type_name = 'REIT'
					break
				case 'titulos':
					this.product_type_name = 'TesouroDireto'
					break
			}
		},


		setOriginClick(tipo) {
			if (tipo == 'eua') {
				this.origin_click = 'eua';
			} else if (tipo == 'br') {
				this.origin_click = 'br';
			} else if (tipo == 'stocks') {
				this.origin_click = 'stocks';
			} else if (tipo == 'reits') {
				this.origin_click = 'reits';
			} else if (tipo == 'acoes') {
				this.origin_click = 'acoes';
			} else if (tipo == 'fiis') {
				this.origin_click = 'fiis';
			}
		},

		async verifyIfReceivedValuesIsNull() {
			if (this.campos_objetivo.pr_renda_variavel_br === 0) {
				this.status_campos.no_has_acoes = true
				this.status_campos.no_has_fiis = true
			}

			if (this.campos_objetivo.pr_renda_variavel_eua === 0) {
				this.status_campos.no_has_reits = true
				this.status_campos.no_has_stocks = true
			}


			if (this.campos_objetivo.pr_renda_variavel == 0) {
				this.status_campos.no_has_eua = true
				this.status_campos.no_has_br = true
				this.status_campos.no_has_acoes = true
				this.status_campos.no_has_fiis = true
				this.status_campos.no_has_stocks = true
				this.status_campos.no_has_reits = true
			}
		},


		updateValueStep(id, tipo = "vazio") {

			console.log(tipo)
			this.isPercentFull = false;
			this.isValid = false;
			this.showError = false;
			this.modalValueIsValid = false;
			this.getDataFromObjective()
			this.setOriginClick(tipo)
			this.step = { id, tipo };
			if (tipo == 'eua' || tipo == 'br') return
			this.defineTypeProduct(this.step.tipo)
			this.verifyStepAndSetThePatterns(id, tipo)


		},

		hasErrorOnInit() {
			Object.entries(this.objetivos).map(([key, value]) => {
				const calculo = value.reduce((acc, i) => acc = acc + Number(i.porcentagem_desejada), 0)
				if (calculo < 100) {
					this.errorSteps.push({ [key]: value })
					this.modal1.openModal(5, key)
					this.updateValueStep(5, key)
					return value
				}
				return
			});


		},


		async getObjetivos(tipo) {
			const entries = Object.entries(this.objetivos).map(([key, value]) => key)

			const dadosCall = entries.map((key) => {
				return axios.get(`${this.baseURL}/api/item_objetivo_${key}/`)
			})
			Promise.all(dadosCall)
				.then((response) => {
					response.forEach(({ data }, index) => {
						const objetivosAtuais = data;
						const objetivoModificado = objetivosAtuais.map((i, idx) => {
							let secoes_ativos = ['pr_acoes', 'pr_fiis', 'pr_stocks', 'pr_reits', 'pr_renda_fixa'];
							const teste2 = this.objetivos_api[0]?.pr_acoes;
							const teste3 = Number(i.porcentagem_desejada);
							i.porcentagem_desejada = (Number(i.porcentagem_desejada)).toFixed(2)
							return i
						});



						this.objetivos[entries[index]] = [...objetivoModificado]
					})
				})
				.catch(error => {
					GLOBAL.showToastify(error, '#DE4B4F')
					console.error(error)
				})
		},

		async getObjetivosIncorretos() {
			try {
				this.loading = true
				const { data } = await axios.get("/api/objetivo/");
				this.incorretos = data[0].incorreto;
			}
			catch (error) {
				console.error(error);
			} finally{
				this.loading = false
			}


		},



		updateNome(nome) {
			this.nome_correto = nome
		},

		openModalAction(value, tipo) {
			this.modalActive.openModal(value);
			if (this.step.id == 1 && this.tipo_atual == 'titulos_inicio' && this.campos_objetivo.pr_renda_fixa) {
				this.updateValueStep(5, 'titulos')
				this.nome_correto = 'Tesouro direto'
				this.product_type_name = 'TesouroDireto'
			}
			// else if (this.step.id == 4 && this.tipo_atual == 'eua') {
			//   this.updateValueStep(5, 'reits')
			// }
			// else if (this.step.id == 3 && this.tipo_atual == 'br') {
			//   this.updateValueStep(5, 'acoes')
			// }

		},

		outsideClick({ target }) {
			if (target.closest(".btn-vermais")) return
			this.quantidadeItens = 3;
		},
		handleToggle(tipo) {
			const isThree = this.quantidadeItens == 3 ? this.quantidadeItens = this.tiposInvestimento[tipo].length : this.quantidadeItens = 3
			console.log(isThree)
			return isThree
		},







	},

	delimiters: ["{*", "*}"], //delimitadores pra n conflitar com o django

}